import http from '../../../httpRequests.js';

export default {
    state(){
        return{
          
            url:'user/update',
            
           

        }
    }, 
  

    actions:{
        async updateProfile(context, payload){
        const response= await http.put(context.state.url, context.rootState.lang,payload, context.rootState.token);
        
       return response;
       

        }
    }
,
   
}